/**
 * Created by swandelow on 19/12/17.
 */
import {Injectable} from "@angular/core";
import {UrlHandlingStrategy} from "@angular/router";
import {PathLocationStrategy} from "@angular/common";
import * as _ from "lodash";

export class Ng1Ng2UrlHandlingStrategy implements UrlHandlingStrategy {

    shouldProcessUrl(url) {
        var migratedPages = [/audit-a2/,/sample/,/(company\/)([0-9]+)(\/contact)/,/(company\/)([0-9]+)(\/pickupPointFee)(\/[0-9])*/,
            /internal-error/, /(company\/)([0-9]+)(\/home)/,/(company\/)([0-9]+)(\/restrictions)(\/[0-9])*/,
            /(company\/)([0-9]+)(\/additionals)(\/[0-9])*/, /booking/, /(company\/)([0-9]+)(\/booking)(\/[0-9])*/,/logout/,
            /(company\/)([0-9]+)(\/insurances)(\/[0-9])*/, /(company\/)([0-9]+)(\/pointsOfSale)(\/[0-9])*/,
            /(company\/)([0-9]+)(\/additionalPoint)(\/[0-9])*/, /(company\/)([0-9]+)(\/agerange)(\/[0-9])*/,
            /(company\/)([0-9]+)(\/carTemplate)(\/[0-9])*/,  /moderateCarTemplate/];
        return _.some(migratedPages, (page) => {
            return this.isMigratedPage(url, page);
        });
    }

    private isMigratedPage(url: any, page: any) {
        return url.toString().match(page) != null;
    }


    extract(url) {
        return url;
    }

    merge(url, whole) {
        return url;
    }
}

@Injectable()
export class CustomLocationStrategy extends PathLocationStrategy {
    prepareExternalUrl(internal: string): string {
        const url = this.getBaseHref() + (internal.startsWith("/cars-sara-v2/web/") ?
            internal.substring(18) : (internal.startsWith("/")?internal.substring(1,internal.length):internal));
        return url;
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/url-handling-strategy.ts